import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Input, InputNumber, Select} from 'antd'
const Option = Select.Option

@inject('store') @observer
class Value extends Component {
  state = {
    inputLength: 0,
    selectionStart: 0
  }
  componentDidMount() {
    if (this.props.condition.tagValueType === 'string') {
      this.props.condition.loadValueSuggestions()
    }
  }
  componentDidUpdate(prevProps) {
    const next = this.props.condition
    const current = prevProps.condition
    if (next.tagValueType === 'string' && next.tag !== current.tag) {
      this.props.condition.loadValueSuggestions()
    }
  }
  handleChange = (value) => {
    this.props.condition.change('value', value)
  }
  render() {
    const {condition} = this.props
    const {value, valueSuggestions, loadingValueSuggestions, tagValueType} = condition
    const options = valueSuggestions?.map(row => <Option key={row.value}>{row.display_value}</Option>) || []
    if (tagValueType === 'string') {
      return(
        <div>
          <label>Value:</label>
          {!options.length
            ? <Input
              onFocus={condition.loadValueSuggestions}
              value={value}
              onChange={this.handleChange}
              size='large'
            />
            : <Select
              value={value}
              onChange={this.handleChange}
              onFocus={condition.loadValueSuggestions}
              showSearch
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              notFoundContent={loadingValueSuggestions ? 'Loading' : 'Not Found'}
              size='large'
            >
              {options}
            </Select>
          }
        </div>
      )
    } else {
      return(
        <div>
          <label>Value:</label>
          <InputNumber
            onChange={this.handleChange}
            value={value}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/[^0-9.]+/g, '')}
            size='large'
          />
        </div>
      )
    }
  }
}

export default Value
